import React from "react";
import { useBlocker } from "react-router-dom";
import CloseIcon from "../../components/ui/icons/CloseIcon";

interface ExitModalProps {
  isCompleted: boolean;
}

const ExitModal: React.FC<ExitModalProps> = ({ isCompleted }) => {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      !isCompleted && currentLocation.pathname !== nextLocation.pathname,
  );

  const handleStay = () => {
    if (blocker.state === "blocked") blocker.reset();
  };

  const handleExit = () => {
    if (blocker.state === "blocked") blocker.proceed();
  };

  if (blocker.state !== "blocked") return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 z-50 flex items-center justify-center px-4"
        style={{ background: "rgba(0,0,0,0.45)" }}
        onClick={handleStay}
      >
        {/* Modal */}
        <div
          className="relative bg-white w-full max-w-[600px] rounded-xl p-8 sm:p-10"
          style={{ boxShadow: "0 10px 40px rgba(0,0,0,0.18)" }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close */}
          <button
            onClick={handleStay}
            className="absolute top-5 right-6 text-dark-blue font-semibold text-[15px] hover:opacity-70 transition font-primary border-none bg-transparent cursor-pointer"
          >
            <CloseIcon />
          </button>

          {/* Title */}
          <h2
            className="font-bold text-dark-blue my-4 text-center leading-tight font-primary"
            style={{ fontSize: "clamp(24px, 4vw, 30px)" }}
          >
            Are you sure you want to leave?
          </h2>

          {/* Description */}
          <p
            className="text-meta leading-relaxed mb-8 font-primary"
            style={{ fontSize: "clamp(14px, 1.5vw, 16px)" }}
          >
            If you leave the survey without saving, some of your data may be
            lost. Click save at the bottom of the screen to save your data
            before exiting.
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={handleStay}
              className="btn btn-normal flex-1 py-4 text-[16px]"
            >
              No, I'll Stay
            </button>

            <button
              onClick={handleExit}
              className="btn btn-normal flex-1 py-4 text-[16px] font-semibold rounded-xl border-2 border-blue text-dark-blue bg-transparent hover:bg-blue hover:text-white transition-all duration-200 font-primary cursor-pointer"
            >
              Yes, exit the survey
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExitModal;
